if (import.meta.env.DEV) {
  (async () => {
    const res = await fetch("/remote-head", {
      credentials: "include",
      headers: { Accept: "text/html" },
    });
    if (res.ok) {
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      for (const meta of doc.querySelectorAll("meta")) {
        const newMeta = document.createElement("meta");
        for (const attr of meta.attributes) {
          newMeta.setAttribute(attr.name, attr.value);
        }
        const key =
          meta.getAttribute("name") || meta.getAttribute("property") || "";
        if (key) {
          document.head
            .querySelectorAll(`meta[name="${key}"], meta[property="${key}"]`)
            .forEach(old => old.remove());
        }
        document.head.appendChild(newMeta);
      }

      for (const s of doc.querySelectorAll("script:not([src])")) {
        const matchLines = (s.textContent || "").match(
          /window\.[\w$_.]+\s*=\s*[^;]+;/g
        );
        matchLines?.forEach(line => {
          try {
            eval(line);
          } catch {
            /* skip */
          }
        });
      }
    }
    await import("./main");
  })();
} else {
  import("./main");
}
